var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartLightBolt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12.58c0 4.64 3.955 9.204 10.203 13.126.232.142.564.294.797.294.233 0 .565-.152.809-.294C23.045 21.784 27 17.22 27 12.579 27 8.723 24.308 6 20.719 6c-2.05 0-3.711.959-4.719 2.43C15.014 6.97 13.33 6 11.281 6 7.691 6 5 8.723 5 12.58zm1.784 0c0-2.898 1.905-4.826 4.475-4.826 2.083 0 3.279 1.274 3.988 2.363.299.436.487.556.753.556s.432-.13.753-.556c.765-1.067 1.917-2.363 3.988-2.363 2.57 0 4.476 1.928 4.476 4.825 0 4.053-4.354 8.42-8.984 11.45-.111.076-.188.13-.233.13s-.122-.054-.221-.13c-4.642-3.03-8.995-7.397-8.995-11.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16.562a.31.31 0 0 0 .317.313h2.38l-1.267 3.587c-.173.475.317.738.605.353l3.84-5.082A.49.49 0 0 0 19 15.44a.328.328 0 0 0-.327-.323h-2.38l1.267-3.577c.173-.485-.307-.737-.605-.353l-3.84 5.082a.474.474 0 0 0-.115.293z",
    opacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartLightBolt);
export default __webpack_public_path__ + "static/media/Heart-Light_Bolt.f74bcc2fc4028eeb637cd392e8e6a740.svg";
export { ForwardRef as ReactComponent };